"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _XXF5DFSGcjs = require('../__chunks/XXF5DFSG.cjs');
require('../__chunks/5OZ7J4C2.cjs');


var _EESDYGNHcjs = require('../__chunks/EESDYGNH.cjs');
require('../__chunks/HYJVIPVI.cjs');
require('../__chunks/OTCKJ4OK.cjs');
require('../__chunks/MXJUUCSD.cjs');
require('../__chunks/6P52IAFY.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MPIQVHCB.cjs');
require('../__chunks/ITCIC2TC.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-dismiss.tsx
var TagName = "button";
var useMenuDismiss = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuDismiss2({ store, ...props }) {
    const context = _XXF5DFSGcjs.useMenuScopedContext.call(void 0, );
    store = store || context;
    props = _EESDYGNHcjs.useHovercardDismiss.call(void 0, { store, ...props });
    return props;
  }
);
var MenuDismiss = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuDismiss2(props) {
  const htmlProps = useMenuDismiss(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuDismiss = MenuDismiss; exports.useMenuDismiss = useMenuDismiss;
